const Errors = {
  CHALLENGE_NAME_EMPTY: 'NAME_EMPTY',
  NO_ROW_SELECTED: 'NO_ROW_SELECTED',
  ROW_NAME_EMPTY: 'ROW_NAME_EMPTY'
};

export default Errors;
